import { ConfirmedDeal } from '../../../types/empresa';
import { Link, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../api/auth/authSlice';
import { VendedorItem } from '../Calendario/VendedorItem';
import { VisitOptionMenu } from './VisitOptionMenu';
import { VisitDate } from './VisitDate';
import { AvailableTurnos } from '../../../types/visitas';
import { ROLES } from '../../../utils/enums';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';

interface Props {
    deal: ConfirmedDeal;
}

export function ConfirmedDealCard({ deal }: Props) {
    const location = useLocation();
    const user = useSelector(selectCurrentUser);

    return (
        <div className={`min-w-[1050px] shrink-0 p-[12px] flex justify-between rounded-xl shadow-sm h-[120px] border ${user != null && deal.prospectadorId === user.id ? "bg-gray-100 border-gray-600" : "bg-white border-gray-300"}`}>

            <div className='flex gap-x-5 h-full'>

                <VisitDate 
                    fecha={deal.fechaVisita}
                    horaInicio={deal.horaInicio}
                    turno={deal.turno as AvailableTurnos}/>

                <div className="h-full border-l border-gray-300" />
            </div>

            <div className="min-w-[350px] h-full">

                <div className="border-2s border-green-500 pb-2">
                    <div className="flex gap-x-1 items-center">
                        <BusinessRoundedIcon sx={{ width: 25, height: 25 }} />
                        {user != null && user.id === deal.prospectadorId
                        ?
                        <Link 
                            className="w-fit" 
                            to={`/empresa/${deal.empresaId}`}
                            state={{ fromName: "calendario (empresas)", fromPath: location.pathname }}>
                            <p className="font-semibold text-xl text-ellipsis truncate">{deal.nombre}</p>
                        </Link>
                        : <p className="font-semibold text-xl truncate">{deal.nombre}</p>
                        }
                    </div>

                    <p className="font-semibold text-[12px] h-[18px]">{deal.sucursal}</p>
                </div>

                <div className="flex gap-x-3 justify-between">
                    <div>
                        <p className="text-sm font-semibold">Tipo de empresa</p>
                        <p className="w-full h-[26px] font-semibold text-gray-600 text-sm">
                            {deal.tipoEmpresa}
                        </p>
                    </div>

                    <div>
                        <p className="text-sm font-semibold">Status</p>
                        <p className="w-full h-[26px] font-semibold text-gray-600 text-sm">
                            {deal.terminado ? "Terminada" : "Abierta"}
                        </p>
                    </div>

                    <div>
                        <p className="text-sm font-semibold">Hora de la visita</p>
                        <p className="w-full h-[26px] font-semibold text-gray-600 text-sm">
                            {deal.horaInicio}
                        </p>
                    </div>
                </div>

            </div>

            <div className="h-full border-l border-gray-300" />

            <div className="h-full w-[140px]">
                <p className="text-[13px] font-semibold">Prospectador: </p>
                <div className="flex gap-x-1 items-center">
                    <div className="bg-gray-300 rounded-full w-[20px] h-[20px]"></div>
                    <p>{deal.prospectadorName}</p>
                </div>
            </div>
                
            <div className="h-full border-l border-gray-300" />

            <div className="h-full w-[320px]">
                <p className="text-[13px] font-semibold">Vendedores: </p>
                <ul className="overflow-auto max-h-[75px]">
                    {deal.vendedores.length == 0
                    ? <p className="italic">No hay vendedores asignados a esta campaña</p>
                    :
                    <>
                    {deal.vendedores.map((vendedor, index) => (
                        <VendedorItem 
                            key={index}
                            prospectadorId={deal.prospectadorId}
                            userId={user?.id ?? 0}
                            visitaId={deal.id}
                            vendedorId={vendedor.id}
                            nombreVendedor={vendedor.nombre}
                            isFinished={deal.terminado}
                            />
                        ))}
                    </>}
                </ul>
            </div>

            <div className="h-full border-l border-transparent"/>

            {user != null && (user.role == ROLES.ADMIN || deal.prospectadorId === user.id) && (
                <VisitOptionMenu  deal={deal}/>
            )}

        </div>
    );
}